(function() {
  function getColorFromFilename(src) {
    if (!src) return null;
    var upper = src.toUpperCase();
    if (upper.indexOf('_TAN') > -1) return 'tan';
    if (upper.indexOf('_SANDRIFT') > -1) return 'sandrift';
    if (upper.indexOf('_BROWN') > -1) return 'brown';
    if (upper.indexOf('_BLACK') > -1) return 'black';
    return null;
  }

  function filterGallery(selectedColor) {
    var color = selectedColor.toLowerCase().trim();
    var $gallery = $('.halo-productView-left[data-image-gallery]');
    if (!$gallery.length) return;

    // Filter main image wrapper
    $gallery.find('.productView-image-wrapper').each(function() {
      var src = $(this).find('img').attr('src') || 
                $(this).find('img').attr('data-srcset') || '';
      var imgColor = getColorFromFilename(src);
      if (!imgColor || imgColor === color) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    // Filter thumbnails
    var $slider = $gallery.find('.productView-for');
    var $thumbSlider = $gallery.find('.productView-thumbnail-wrapper');

    $gallery.find('.productView-thumbnail-link').each(function() {
      var src = $(this).attr('data-image') || '';
      var imgColor = getColorFromFilename(src);
      var $slide = $(this).closest('.slick-slide:not(.slick-cloned)');
      if (!imgColor || imgColor === color) {
        $slide.show();
      } else {
        $slide.hide();
      }
    });

    // Go to first visible slide
    var firstVisible = $gallery.find('.productView-thumbnail-link').filter(function() {
      var src = $(this).attr('data-image') || '';
      var imgColor = getColorFromFilename(src);
      return !imgColor || imgColor === color;
    }).first().closest('.slick-slide').data('slick-index');

    if (typeof firstVisible !== 'undefined' && $slider.hasClass('slick-initialized')) {
      $slider.slick('slickGoTo', firstVisible || 0);
    }
  }

  function getSelectedColor() {
    // Try radio/swatch input
    var $checked = $('input[name="Color"]:checked, input[data-option="Color"]:checked');
    if ($checked.length) return $checked.val();

    // Try select
    var $select = $('select[name="Color"], select[data-option="Color"]');
    if ($select.length) return $select.val();

    // Try active swatch label
    var $active = $('.swatch__list .swatch-item--active, .variant-swatch.active, [data-option-value].active');
    if ($active.length) return $active.data('value') || $active.val() || $active.text().trim();

    // Try URL param
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('color') || urlParams.get('Color') || '';
  }

  function init() {
    // Run on page load
    var initColor = getSelectedColor();
    if (initColor) filterGallery(initColor);

    // Listen for swatch clicks
    $(document).on('click', '.swatch__list label, .swatch__list input, [data-option-value]', function() {
      setTimeout(function() {
        var color = getSelectedColor();
        if (color) filterGallery(color);
      }, 100);
    });

    // Listen for select change
    $(document).on('change', 'select[name="Color"], select[data-option="Color"]', function() {
      filterGallery($(this).val());
    });

    // Listen for Halo/Shopify variant events
    $(document).on('variant:change variantChange', function(e) {
      var color = getSelectedColor();
      if (color) filterGallery(color);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
